import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const AddPhotoIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    viewBox="0 0 22 21"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.206 11.27a.494.494 0 0 1 .758 0l1.948 2.336c.197.237.56.237.758 0l4.143-4.967a.494.494 0 0 1 .758 0l1.915 2.297a5.527 5.527 0 0 1 2.489-.29V1.594c0-.613-.498-1.111-1.11-1.111H2.001c-.612 0-1.11.498-1.11 1.11V15.67c0 .613.498 1.11 1.11 1.11h9.838a5.582 5.582 0 0 1 0-1.233H2.126v-.583l3.08-3.693zm.744-7.6a1.878 1.878 0 1 1 0 3.756 1.878 1.878 0 0 1 0-3.757zm11.408 8.175a4.32 4.32 0 1 0 0 8.638 4.32 4.32 0 0 0 0-8.638zm2.254 4.936h-1.637v1.637a.617.617 0 1 1-1.234 0V16.78h-1.637a.617.617 0 1 1 0-1.234h1.637V13.91a.617.617 0 1 1 1.234 0v1.637h1.637a.617.617 0 1 1 0 1.234z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

AddPhotoIcon.propTypes = propTypes;

export default AddPhotoIcon;
